import { useMutation } from 'react-query';

import { get } from 'lodash';

import { useCurrentLanguage, useCurrentUser } from '@lib/hooks';
import axiosClient from '@lib/utils/axiosClient';

import { Patient } from '../types';

type Data = Partial<Patient>;

type Response = string;

export default function usePatientLogin() {
  const currentUser = useCurrentUser();
  const language = useCurrentLanguage();

  // NOTE: backend is spreading scheduler settings for widget users
  const schedulerSettings = get(currentUser, 'settings.scheduler') || get(currentUser, 'settings');
  const createPatientOnLookupFailure = get(schedulerSettings, 'createPatientOnLookupFailure', true);

  const mutationFn = async (data: Data) => {
    // Check if the patient exists
    let response;
    try {
      response = await axiosClient.post('/patients/login', data);
    } catch (e) {
      if (createPatientOnLookupFailure) {
        // Create patient if it doesn't exist and `createPatientOnLookupFailure: true`
        response = await axiosClient.post('/patients', {
          ...data,
          language,
          source: 'widget',
        });
      } else {
        throw e;
      }
    }
    return response.data._id as Response;
  };

  const patientLogin = useMutation(mutationFn);

  return patientLogin;
}
